/* eslint-disable max-lines */
/* prettier-ignore */

export const colorsClassesMap = {
  'surface-positive-disabled': 'color_surface-positive-disabled',
  'surface-positive-default': 'color_surface-positive-default',
  'surface-positive-hovered': 'color_surface-positive-hovered',
  'surface-positive-pressed': 'color_surface-positive-pressed',
  'surface-positive-selected': 'color_surface-positive-selected',
  'stroke-divider-default': 'color_stroke-divider-default',
  'stroke-divider-neutral': 'color_stroke-divider-neutral',
  'text-primary-default': 'color_text-primary-default',
  'text-primary-hovered': 'color_text-primary-hovered',
  'text-primary-pressed': 'color_text-primary-pressed',
  'text-primary-disabled': 'color_text-primary-disabled',
  'text-secondary-default': 'color_text-secondary-default',
  'text-secondary-hovered': 'color_text-secondary-hovered',
  'text-secondary-pressed': 'color_text-secondary-pressed',
  'text-secondary-disabled': 'color_text-secondary-disabled',
  'text-inverted-default': 'color_text-inverted-default',
  'text-inverted-hovered': 'color_text-inverted-hovered',
  'text-inverted-pressed': 'color_text-inverted-pressed',
  'text-inverted-disabled': 'color_text-inverted-disabled',
  'text-main-default': 'color_text-main-default',
  'text-main-hovered': 'color_text-main-hovered',
  'text-main-pressed': 'color_text-main-pressed',
  'text-main-disabled': 'color_text-main-disabled',
  'text-positive-default': 'color_text-positive-default',
  'text-positive-hovered': 'color_text-positive-hovered',
  'text-positive-pressed': 'color_text-positive-pressed',
  'text-positive-disabled': 'color_text-positive-disabled',
  'text-warning-default': 'color_text-warning-default',
  'text-warning-hovered': 'color_text-warning-hovered',
  'text-warning-pressed': 'color_text-warning-pressed',
  'text-warning-disabled': 'color_text-warning-disabled',
  'text-negative-default': 'color_text-negative-default',
  'text-negative-hovered': 'color_text-negative-hovered',
  'text-negative-pressed': 'color_text-negative-pressed',
  'text-negative-disabled': 'color_text-negative-disabled',
  'text-on-bright-default': 'color_text-on-bright-default',
  'text-on-bright-hovered': 'color_text-on-bright-hovered',
  'text-on-bright-pressed': 'color_text-on-bright-pressed',
  'text-on-bright-disabled': 'color_text-on-bright-disabled',
  'control-main-primary-default': 'color_control-main-primary-default',
  'control-main-primary-hovered': 'color_control-main-primary-hovered',
  'control-main-primary-pressed': 'color_control-main-primary-pressed',
  'control-main-primary-disabled': 'color_control-main-primary-disabled',
  'control-main-secondary-default': 'color_control-main-secondary-default',
  'control-main-secondary-hovered': 'color_control-main-secondary-hovered',
  'control-main-secondary-pressed': 'color_control-main-secondary-pressed',
  'control-main-secondary-disabled': 'color_control-main-secondary-disabled',
  'stroke-control-default': 'color_stroke-control-default',
  'stroke-control-hovered': 'color_stroke-control-hovered',
  'stroke-control-pressed': 'color_stroke-control-pressed',
  'stroke-control-selected': 'color_stroke-control-selected',
  'stroke-control-disabled': 'color_stroke-control-disabled',
  'stroke-border-default': 'color_stroke-border-default',
  'stroke-border-neutral': 'color_stroke-border-neutral',
  'stroke-border-main': 'color_stroke-border-main',
  'stroke-border-positive': 'color_stroke-border-positive',
  'stroke-border-warning': 'color_stroke-border-warning',
  'stroke-border-negative': 'color_stroke-border-negative',
  'stroke-control-focused': 'color_stroke-control-focused',
  'icon-primary-default': 'color_icon-primary-default',
  'icon-primary-hovered': 'color_icon-primary-hovered',
  'icon-primary-pressed': 'color_icon-primary-pressed',
  'icon-primary-disabled': 'color_icon-primary-disabled',
  'icon-secondary-default': 'color_icon-secondary-default',
  'icon-secondary-hovered': 'color_icon-secondary-hovered',
  'icon-secondary-pressed': 'color_icon-secondary-pressed',
  'icon-secondary-disabled': 'color_icon-secondary-disabled',
  'icon-inverted-default': 'color_icon-inverted-default',
  'icon-inverted-hovered': 'color_icon-inverted-hovered',
  'icon-inverted-pressed': 'color_icon-inverted-pressed',
  'icon-inverted-disabled': 'color_icon-inverted-disabled',
  'icon-main-default': 'color_icon-main-default',
  'icon-main-hovered': 'color_icon-main-hovered',
  'icon-main-pressed': 'color_icon-main-pressed',
  'icon-main-disabled': 'color_icon-main-disabled',
  'icon-positive-default': 'color_icon-positive-default',
  'icon-positive-hovered': 'color_icon-positive-hovered',
  'icon-positive-pressed': 'color_icon-positive-pressed',
  'icon-positive-disabled': 'color_icon-positive-disabled',
  'icon-warning-default': 'color_icon-warning-default',
  'icon-warning-hovered': 'color_icon-warning-hovered',
  'icon-warning-pressed': 'color_icon-warning-pressed',
  'icon-warning-disabled': 'color_icon-warning-disabled',
  'icon-negative-default': 'color_icon-negative-default',
  'icon-negative-hovered': 'color_icon-negative-hovered',
  'icon-negative-pressed': 'color_icon-negative-pressed',
  'icon-negative-disabled': 'color_icon-negative-disabled',
  'icon-on-bright-default': 'color_icon-on-bright-default',
  'icon-on-bright-hovered': 'color_icon-on-bright-hovered',
  'icon-on-bright-pressed': 'color_icon-on-bright-pressed',
  'icon-on-bright-disabled': 'color_icon-on-bright-disabled',
  'control-positive-primary-default': 'color_control-positive-primary-default',
  'control-positive-primary-hovered': 'color_control-positive-primary-hovered',
  'control-positive-primary-pressed': 'color_control-positive-primary-pressed',
  'control-positive-primary-disabled': 'color_control-positive-primary-disabled',
  'control-positive-secondary-default': 'color_control-positive-secondary-default',
  'control-positive-secondary-hovered': 'color_control-positive-secondary-hovered',
  'control-positive-secondary-pressed': 'color_control-positive-secondary-pressed',
  'control-positive-secondary-disabled': 'color_control-positive-secondary-disabled',
  'control-warning-primary-default': 'color_control-warning-primary-default',
  'control-warning-primary-hovered': 'color_control-warning-primary-hovered',
  'control-warning-primary-pressed': 'color_control-warning-primary-pressed',
  'control-warning-primary-disabled': 'color_control-warning-primary-disabled',
  'control-warning-secondary-default': 'color_control-warning-secondary-default',
  'control-warning-secondary-hovered': 'color_control-warning-secondary-hovered',
  'control-warning-secondary-pressed': 'color_control-warning-secondary-pressed',
  'control-warning-secondary-disabled': 'color_control-warning-secondary-disabled',
  'control-negative-primary-default': 'color_control-negative-primary-default',
  'control-negative-primary-hovered': 'color_control-negative-primary-hovered',
  'control-negative-primary-pressed': 'color_control-negative-primary-pressed',
  'control-negative-primary-disabled': 'color_control-negative-primary-disabled',
  'control-negative-secondary-default': 'color_control-negative-secondary-default',
  'control-negative-secondary-hovered': 'color_control-negative-secondary-hovered',
  'control-negative-secondary-pressed': 'color_control-negative-secondary-pressed',
  'control-negative-secondary-disabled': 'color_control-negative-secondary-disabled',
  'control-inverted-primary-default': 'color_control-inverted-primary-default',
  'control-inverted-primary-hovered': 'color_control-inverted-primary-hovered',
  'control-inverted-primary-pressed': 'color_control-inverted-primary-pressed',
  'control-inverted-primary-disabled': 'color_control-inverted-primary-disabled',
  'surface-warning-default': 'color_surface-warning-default',
  'surface-warning-hovered': 'color_surface-warning-hovered',
  'surface-warning-pressed': 'color_surface-warning-pressed',
  'surface-warning-selected': 'color_surface-warning-selected',
  'surface-warning-disabled': 'color_surface-warning-disabled',
  'surface-negative-default': 'color_surface-negative-default',
  'surface-negative-hovered': 'color_surface-negative-hovered',
  'surface-negative-pressed': 'color_surface-negative-pressed',
  'surface-negative-selected': 'color_surface-negative-selected',
  'surface-negative-disabled': 'color_surface-negative-disabled',
  'surface-main-default': 'color_surface-main-default',
  'surface-main-hovered': 'color_surface-main-hovered',
  'surface-main-pressed': 'color_surface-main-pressed',
  'surface-main-selected': 'color_surface-main-selected',
  'surface-main-disabled': 'color_surface-main-disabled',
  'surface-neutral-default': 'color_surface-neutral-default',
  'surface-neutral-hovered': 'color_surface-neutral-hovered',
  'surface-neutral-pressed': 'color_surface-neutral-pressed',
  'surface-neutral-selected': 'color_surface-neutral-selected',
  'surface-neutral-disabled': 'color_surface-neutral-disabled',
  'background-primary': 'color_background-primary',
  'background-secondary': 'color_background-secondary',
  'background-elevation': 'color_background-elevation',
  'decorative-orange': 'color_decorative-orange',
  'decorative-yellow': 'color_decorative-yellow',
  'decorative-purple': 'color_decorative-purple',
  'decorative-violet': 'color_decorative-violet',
  'decorative-magentum': 'color_decorative-magentum',
  'decorative-lavender': 'color_decorative-lavender',
  'decorative-lavender-transparent': 'color_decorative-lavender-transparent',
  'decorative-deeporange-vas': 'color_decorative-deeporange-vas',
  'decorative-blackberry': 'color_decorative-blackberry',
  'decorative-blackberry-dark': 'color_decorative-blackberry-dark',
  'theme-blue': 'color_theme-blue',
  'theme-green': 'color_theme-green',
  'theme-orange': 'color_theme-orange',
  'theme-red': 'color_theme-red',
  'theme-gray': 'color_theme-gray',
  'theme-dark': 'color_theme-dark',
  'theme-black': 'color_theme-black',
  'theme-white': 'color_theme-white',
  'subscription-bronze': 'color_subscription-bronze',
  'subscription-silver': 'color_subscription-silver',
  'subscription-gold': 'color_subscription-gold',
  'subscription-platinum': 'color_subscription-platinum',
  'shadow-default': 'color_shadow-default',
  'overlay-default': 'color_overlay-default',
  'overlay-control-inverted': 'color_overlay-control-inverted',
  'overlay-control-default': 'color_overlay-control-default',
  'overlay-media-banner': 'color_overlay-media-banner',
  'overlay-popover': 'color_overlay-popover',
  'overlay-negative': 'color_overlay-negative',
  'surface-inverted-default': 'color_surface-inverted-default',
  'surface-inverted-hovered': 'color_surface-inverted-hovered',
  'surface-inverted-pressed': 'color_surface-inverted-pressed',
  'surface-inverted-selected': 'color_surface-inverted-selected',
  'surface-inverted-disabled': 'color_surface-inverted-disabled',
  'accent-ghost-primary': 'color_accent-ghost-primary',
  'accent-main-secondary': 'color_accent-main-secondary',
  'accent-positive-secondary': 'color_accent-positive-secondary',
  'accent-warning-secondary': 'color_accent-warning-secondary',
  'accent-negative-secondary': 'color_accent-negative-secondary',
  'accent-ghost-secondary': 'color_accent-ghost-secondary',
  'accent-main-primary': 'color_accent-main-primary',
  'accent-positive-primary': 'color_accent-positive-primary',
  'accent-warning-primary': 'color_accent-warning-primary',
  'accent-negative-primary': 'color_accent-negative-primary',
  'stroke-divider-main': 'color_stroke-divider-main',
  'stroke-divider-positive': 'color_stroke-divider-positive',
  'stroke-divider-warning': 'color_stroke-divider-warning',
  'stroke-divider-negative': 'color_stroke-divider-negative',
  'brand-cyan': 'color_brand-cyan',
  'brand-space': 'color_brand-space',
  'brand-midnight': 'color_brand-midnight',
  'brand-navy': 'color_brand-navy',
  'brand-royalblue': 'color_brand-royalblue',
  'brand-indigo': 'color_brand-indigo',
  'brand-sapphire': 'color_brand-sapphire',
  'brand-lapis': 'color_brand-lapis',
  'brand-azure': 'color_brand-azure',
  'brand-cornflowerblue': 'color_brand-cornflowerblue',
  'brand-sky': 'color_brand-sky',
  'brand-denim': 'color_brand-denim',
  'brand-iris': 'color_brand-iris',
  'brand-mauve': 'color_brand-mauve',
  'brand-pink': 'color_brand-pink',
  'brand-peach': 'color_brand-peach',
  'brand-sand': 'color_brand-sand',
  'brand-white': 'color_brand-white',
  'brand-black': 'color_brand-black',
  current_color: 'color_current_color'
};
export const gradientsClassesMap = {
  'skeleton-primary': 'gradient_skeleton-primary',
  'brand-public-primary': 'gradient_brand-public-primary',
  'brand-public-secondary': 'gradient_brand-public-secondary',
  'brand-b2b-primary': 'gradient_brand-b2b-primary',
  'brand-b2b-secondary': 'gradient_brand-b2b-secondary',
  'brand-mortgage-primary': 'gradient_brand-mortgage-primary',
  'brand-mortgage-secondary': 'gradient_brand-mortgage-secondary',
  'brand-owner-primary': 'gradient_brand-owner-primary',
  'brand-owner-secondary': 'gradient_brand-owner-secondary',
  'brand-commercial-primary': 'gradient_brand-commercial-primary',
  'brand-commercial-secondary': 'gradient_brand-commercial-secondary',
  'brand-commercial-tertiary': 'gradient_brand-commercial-tertiary'
};
const gradientsMap = {
  'skeleton-primary': function () {
    let angle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 270;
    return "linear-gradient(".concat(angle, "deg, var(--surface-neutral-default) 0%, var(--surface-neutral-default) 20%, var(--surface-inverted-default) 50%, var(--surface-neutral-default) 80%, var(--surface-neutral-default) 100%)");
  },
  'brand-public-primary': function () {
    let angle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 270;
    return "linear-gradient(".concat(angle, "deg, var(--brand_lapis) 0%, var(--brand_pink) 100%)");
  },
  'brand-public-secondary': function () {
    let angle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 270;
    return "linear-gradient(".concat(angle, "deg, var(--brand_cyan) 0%, var(--brand_pink) 100%)");
  },
  'brand-b2b-primary': function () {
    let angle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 270;
    return "linear-gradient(".concat(angle, "deg, var(--brand_sand) 0%, var(--brand_peach) 20%, var(--brand_pink) 40%, var(--brand_lapis) 60%, var(--brand_navy) 80%, var(--solid-black) 100%)");
  },
  'brand-b2b-secondary': function () {
    let angle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 270;
    return "linear-gradient(".concat(angle, "deg, var(--brand_navy) 0%, var(--brand_lapis) 20%, var(--brand_pink) 40%, var(--brand_peach) 60%, var(--brand_sand) 80%, var(--solid-white) 100%)");
  },
  'brand-mortgage-primary': function () {
    let angle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 270;
    return "linear-gradient(".concat(angle, "deg, var(--brand_lapis) 0%, var(--brand_sky) 50%, var(--brand_peach) 100%)");
  },
  'brand-mortgage-secondary': function () {
    let angle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 270;
    return "linear-gradient(".concat(angle, "deg, var(--brand_cyan) 0%, var(--brand_peach) 100%)");
  },
  'brand-owner-primary': function () {
    let angle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 270;
    return "linear-gradient(".concat(angle, "deg, var(--brand_lapis) 0%, var(--brand_denim) 50%, var(--brand_sand) 100%)");
  },
  'brand-owner-secondary': function () {
    let angle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 270;
    return "linear-gradient(".concat(angle, "deg, var(--brand_cyan) 0%, var(--brand_sand) 100%)");
  },
  'brand-commercial-primary': function () {
    let angle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 270;
    return "linear-gradient(".concat(angle, "deg, var(--brand_peach) 0%, var(--brand_sand) 50%, var(--brand_pink) 100%)");
  },
  'brand-commercial-secondary': function () {
    let angle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 270;
    return "linear-gradient(".concat(angle, "deg, var(--brand_lapis) 0%, var(--solid-white) 100%)");
  },
  'brand-commercial-tertiary': function () {
    let angle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 270;
    return "linear-gradient(".concat(angle, "deg, var(--solid-black) 0%, var(--brand_lapis) 100%)");
  }
};
export const getGradient = (name, angle) => {
  return gradientsMap[name](angle);
};